import { EUserRole } from '__generated__/globalTypes';
import { MainButton } from 'elements/button/MainButton';
import { EHovers } from 'libs/styles/styling';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from 'session/state/context';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

const MENU_ITEMS = [
    {
        label: 'My maps',
        icon: 'map' as const,
        path: '/'
    },
    {
        label: 'Manage users',
        icon: 'user' as const,
        path: '/reseller',
        roles: [EUserRole.ADMIN, EUserRole.RESELLER]
    },
    { label: 'Account', icon: 'gear' as const, path: '/account' }
];

export const MenuHeader = (props: Props): JSX.Element => {
    const globalContext = useContext(GlobalContext);
    const user = globalContext.state.loggedUser;

    return (
        <S_MenuHeader className={props.className}>
            {MENU_ITEMS.map((menuItem) => {
                const isCurrentPath = location.pathname === menuItem.path;
                const buttonElement = (
                    <S_MainButton
                        type={'white'}
                        $selected={isCurrentPath}
                        iconSet="far"
                        iconName={menuItem.icon}
                    >
                        {menuItem.label}
                    </S_MainButton>
                );

                if (menuItem.roles && !menuItem.roles.includes(user.role)) {
                    return null;
                }

                return !isCurrentPath ? (
                    <S_Link key={menuItem.path} to={menuItem.path}>
                        {buttonElement}
                    </S_Link>
                ) : (
                    <S_NonLink key={menuItem.path}>{buttonElement}</S_NonLink>
                );
            })}
        </S_MenuHeader>
    );
};

const S_MenuHeader = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: left;
`;

const S_Link = styled(Link)`
    margin-right: 20px;
    cursor: pointer;
`;

const S_NonLink = styled.div`
    margin-right: 20px;
`;

const S_MainButton = styled(MainButton)<{ $selected: boolean }>`
    box-shadow: ${(props) => props.$selected && EHovers.LIGHT2};
    cursor: ${(props) => (props.$selected ? 'default' : 'pointer')};
    border: ${(props) => props.$selected && '0px'};
    &:hover {
        box-shadow: ${(props) => props.$selected && EHovers.LIGHT2};
    }
`;
